import { ReactNode } from 'react';

interface TitleWithContentProps {
    title: string;
    /**
     * Heading level. Sections of a page use 2 (the default); the page's own main title uses 1.
     * Every page must have exactly one h1.
     */
    level?: 1 | 2 | 3;
    children?: ReactNode; // Adjusted to accept ReactNode
}

const TitleWithContent = ({ title, level = 2, children }: TitleWithContentProps) => {
    const Heading = `h${level}` as 'h1' | 'h2' | 'h3';

    return (
        <>
            <div style={{
                 paddingLeft: "clamp(.2rem, 6vw, 8rem)",
                 paddingRight: "clamp(.2rem, 6vw, 8rem)",
                 marginTop: "clamp(0.2rem, 6vw, 6rem)",   
            }}
            className="group ">
                <Heading className="title-text-size">{title}</Heading>
                <div style={{
                    marginBottom: "clamp(0.2rem, 2vw, 2rem)",
                }} className="custom__divider" />
                {children} 
            </div>
        </>
    );
};

export default TitleWithContent;
